import { EPG_TIMELINE_DAYS_AFTER, EPG_TIMELINE_DAYS_BEFORE } from '@jwp/ott-common/src/constants';
import env from '@jwp/ott-common/src/env';

export const CHANNEL_WIDTH = 240; // width of the channel column
// env is only filled after `configureEnv`, so this must be a function instead of a constant
export const getVisibleHours = () => Number(env.APP_EPG_VISIBLE_HOURS ?? 2);
export const HOURS_BEFORE = EPG_TIMELINE_DAYS_BEFORE * 24;
export const HOURS_AFTER = EPG_TIMELINE_DAYS_AFTER * 24;
export const HOURS_TOTAL = HOURS_BEFORE + 24 + HOURS_AFTER;
export const MS_PER_HOUR = 60 * 60 * 1000;
export const MS_PER_MINUTE = 60 * 1000;
export const HOUR_OFFSET = HOURS_TOTAL / 2;

export const CHANNEL_HEIGHT = 80;
export const CHANNEL_SPACING = 16;
export const CHANNEL_HEIGHT_WITH_SPACING = CHANNEL_HEIGHT + CHANNEL_SPACING;
